const { scp } = require('scp2')
const fs = require('fs')
const eventStream = require('event-stream')

const { 
    begin, 
    finish, 
    error, 
    newline, 
    config,
    inquirer,
    spinner,
} = require('../common.js')

const LOGS_PATH = "/opt/lei/wildfly/logs/lei-dashboard.log"
const getLogDestinationPath = stack => `/tmp/.ops_cli_${stack}.log`

const localData = {}

function logs(yargs) {
	const argv = yargs
		.reset()
		.help("help")
		.alias("h")
        .argv
        
    const name = config.get('name')
    localData.username = name.first.toLowerCase().slice(0, 1) + name.last.toLowerCase()

    begin("logs")
        .then(_getPassword)
        .then(_getRange)
        .then(_copyLogs)
        .then(_cleanUpPassword)
        .then(_parseLogs)
        .then(_printResults)
        .then(finish)
        .catch(err => {
            spinner.stop()
            error("logs", "could not process log files, caused by:\n" + err)
        })

}

function _getRange() {
    return inquirer
        .prompt([
            {
                type: 'text',
                name: 'from',
                message: 'from:',
            },
            {
                type: 'text',
                name: 'to',
                message: 'to:',
            }
        ])
        .then(({ from, to }) => {
            localData.from = new Date(from).valueOf()
            localData.to = new Date(to).valueOf() + 8.64e+7
        })
}

function _getPassword() {
    return inquirer
        .prompt([{
            type: 'password',
            name: 'password',
            message: 'password:',
            mask: '*',
        }])
        .then(({ password }) => {
            localData.password = password
        })
}

function _copyLogs() {
    spinner.start('dowloading logs')
    
    return Promise
        .all([
            _copyLogsFromStack("a"),
            _copyLogsFromStack("b"),
        ])
        .then(() => {
            spinner.stop()
        })
}

function _copyLogsFromStack(stack) {
    return new Promise((resolve, reject) => {
        scp(
            {
                host: `webservices${stack}.avtr.net`,
                username: localData.username,
                password: localData.password,
                path: LOGS_PATH
            }, 
            getLogDestinationPath(stack),
            function(err) {
                if (err)
                    return reject(err)
                else
                    return resolve()
            }
        )
    })
}

function _cleanUpPassword() {
    delete localData.password
    return Promise.resolve()
}

function _parseLogs() {
    spinner.start('parsing logs')
    return Promise
        .all([
            _memorySafeParseLogs(getLogDestinationPath("a")),
            _memorySafeParseLogs(getLogDestinationPath("b")),
        ])
        .then(() => {
            spinner.stop()
        })
}

function _memorySafeParseLogs(path) {

    localData.parsedLogs = {}

    return new Promise((resolve, reject) => {

        let lineNumber = 0
        let lastDate = 0
    
        const stream = fs.createReadStream(path)
            .pipe(eventStream.split())
            .pipe(eventStream.mapSync(line => {
                stream.pause()
                lineNumber++
                    
                const date = _getDateFromLine(line)
                if (date)
                    lastDate = date

                if (lastDate >= localData.from && 
                    lastDate <= localData.to)
                {
                    const parsedLine = _parseLine(line, lastDate)
                    if (parsedLine)
                    {
                        if (!localData.parsedLogs[parsedLine.user])
                            localData.parsedLogs[parsedLine.user] = {}
                        
                        if (!localData.parsedLogs[parsedLine.user][parsedLine.token])
                            localData.parsedLogs[parsedLine.user][parsedLine.token] = {}
                        
                        if (parsedLine.action === 'OPEN')
                            localData.parsedLogs[parsedLine.user][parsedLine.token].openedOn = parsedLine.on
    
                        if (parsedLine.action === 'CLOSE')
                            localData.parsedLogs[parsedLine.user][parsedLine.token].closedOn = parsedLine.on
    
                        if (parsedLine.version)
                            localData.parsedLogs[parsedLine.user][parsedLine.token].version = parsedLine.version
                        
                    }
                }
    
                stream.resume()
            }))
            .on('error', function(err){
                return reject(err)
            })
            .on('end', function(){
                return resolve()
            })
    })

}

function _getDateFromLine(line) {
    const dateRegex = /^\d\d\d\d\-\d\d-\d\d \d\d:\d\d:\d\d/
    const date = line.match(dateRegex) && line.match(dateRegex)[0] 
    
    if (date)
        return new Date(date).valueOf()
    else 
        return null
}

function _parseLine(line, lastDate) {

    const lineRegex = /session:[a-z]+:[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/

    if (!lineRegex.test(line))
        return null

    const [ emoji, action, sessionData, ...rest ] = line.split(" ")
    const [ name, user, token ] = sessionData.split(":")

    const allowedActions = [ 
        "OPEN",
        "CLOSE",
    ]

    if (!allowedActions.includes(action))
        return null

    return {
        action,
        user,
        token,
        on: lastDate,
        version: rest.join(" ").slice(6, -1) || undefined
    }
}

function _printResults() {

    newline()

    Object
        .keys(localData.parsedLogs)
        .sort()
        .forEach(user => {
            console.log("user:", user)

            let sessionsCount = 0
            let unclosedSessionsCount = 0
            let timeLogged = 0

            Object
                .keys(localData.parsedLogs[user])
                .forEach(token => {
                    const {
                        closedOn,
                        openedOn
                    } = localData.parsedLogs[user][token]

                    if (closedOn && openedOn)
                        timeLogged += (closedOn - openedOn)
                    else
                        unclosedSessionsCount ++

                    sessionsCount ++
                })
                
            console.log(`\tsessions: ${sessionsCount}`)

            const timeLoggedInHours = timeLogged/(1000 * 60 * 60)
            const roundedTimeLogged = Math.round(timeLoggedInHours * 100) / 100

            console.log(`\ttime logged: ${roundedTimeLogged} hours`)
            if (unclosedSessionsCount)
                console.log(`\tunclosed sessions: ${unclosedSessionsCount}`)
            
            newline()

        })


    return Promise.resolve()
}

module.exports = logs


// WEBPACK FOOTER //
// ./src/commands/logs.js